/* eslint-disable prefer-destructuring */
// Note process.env is not available at runtine, desctructuring will not work

export const GATSBY_KNOWLEDGE_CENTRE_ENABLED = process.env.GATSBY_KNOWLEDGE_CENTRE_ENABLED
export const GATSBY_HUBSPOT_PORTAL_ID = process.env.GATSBY_HUBSPOT_PORTAL_ID
export const GATSBY_HOST_PATH = process.env.GATSBY_HOST_PATH
export const GATSBY_FAQ_ENABLED = process.env.GATSBY_FAQ_ENABLED